import * as React from 'react';

import { Introduction } from '../IntroductionRedesigned';
import { FixedHeader } from '../FixedHeaderRedesign';
import { Facts } from '../Facts';
import { ContentWrapper } from '../../components/ContentWrapper';
import { AboutContainer } from '../../components/AboutRedesigned';
import { Ratings, Awards } from '../Awards';
import { SpecialPromoRedesign } from '../SpecialPromoRedesign';
import { ProjectsRedesigned } from '../Projects';
import { ProjectsOnMap } from '../ProjectsOnMap/ProjectsOnMapRedesigned';
import { Reviews } from '../Reviews';
import { PromoBannerContainer } from '../PromoBannerContainer';
import { VideoFromDeveloperBlockShSPContainer } from '../VideoFromDeveloperBlockShSPContainer';
import { ApartmentFinishingTemplateSpecialPromoContainer } from '../ApartmentFinishingTemplateSpecialPromoContainer';
import { AdvantagesTemplateSpecialPromoContainer } from '../AdvantagesTemplateSpecialPromoContainer';
import { Responsive } from '@cian/ui-kit';
import { StickyBottomLayout } from '../../components/StickyBottomLayout';
import { MobileCall } from '../MobileCall';
import { ReliabilityContainer } from '../ReliabilityContainer';

export const PageTemplateSpecialPromo: React.FC = () => {
  return (
    <div data-testid="PageTemplateSpecialPromo">
      <Responsive desktop>
        <FixedHeader />
      </Responsive>
      <Introduction />
      <Facts />
      <ContentWrapper>
        <Responsive desktop>
          <PromoBannerContainer />
        </Responsive>
        <AboutContainer />
        <Responsive tablet phone>
          <ReliabilityContainer />
        </Responsive>
        <SpecialPromoRedesign />
        <Ratings />
        <Awards />
        <ProjectsRedesigned />
        <ProjectsOnMap />
        <VideoFromDeveloperBlockShSPContainer />
        <ApartmentFinishingTemplateSpecialPromoContainer />
        <AdvantagesTemplateSpecialPromoContainer />
        <Reviews />
      </ContentWrapper>
      <Responsive tablet phone>
        <StickyBottomLayout>
          <MobileCall />
        </StickyBottomLayout>
      </Responsive>
    </div>
  );
};
